import { ProductActionMenu, type ProductAction } from './products/ProductActionMenu';
import { Card } from './ui/card';
import { CardCarousel } from './ui/card-carousel';
import { type DisplayCrop } from './ui/product-image';
import { Badge } from './ui/badge';
import { Checkbox } from './ui/checkbox';
import { cn } from '@/lib/utils';

export function ProductCard({
	name,
	sku,
	images,
	tags,
	isSelected,
	onSelect,
	onClick,
	actions,
}: {
	name: string;
	sku?: string | null;
	images?: Array<{
		url?: string | null;
		isPrimary?: boolean | null;
		crop?: DisplayCrop | null;
	}> | null;
	tags?: Array<{ name: string }> | null;
	isSelected?: boolean;
	onSelect?: () => void;
	onClick: () => void;
	/** The "…" menu. Omit (or pass none) for a card without one. */
	actions?: ProductAction[];
}) {
	return (
		<Card
			className={cn(
				'group cursor-pointer overflow-hidden bg-surface gap-0 py-0 transition-all duration-[180ms]',
				isSelected
					? 'border-accent ring-1 ring-accent'
					: 'border-line-1 hover:border-line-2'
			)}
			onClick={onClick}
		>
			{/* Image area */}
			<div
				className="relative overflow-hidden border-b border-line-1 bg-media-well"
				style={{ aspectRatio: '1' }}
			>
				<CardCarousel images={images} name={name} />
				{tags && tags.length > 0 && (
					<div className="absolute top-2.5 left-2.5 z-10">
						<Badge className="bg-status-neutral-soft text-xs text-text-3">
							{tags[0].name}
						</Badge>
					</div>
				)}

				{onSelect && (
					<div
						className="absolute top-2.5 right-2.5 z-10"
						onClick={(e) => e.stopPropagation()}
					>
						<Checkbox
							variant="overlay"
							checked={isSelected}
							onCheckedChange={onSelect}
						/>
					</div>
				)}
			</div>

			{/* Info */}
			<div className="px-3.5 pt-3 pb-3.5">
				<div className="mb-1.5 truncate text-base font-medium leading-snug text-text-1">
					{name}
				</div>
				<div className="flex min-h-5 items-center justify-between gap-2">
					<span className="truncate font-mono text-xs text-text-4">{sku || ' '}</span>
					{actions && <ProductActionMenu actions={actions} className="-my-1" />}
				</div>
			</div>
		</Card>
	);
}
